module.exports = __webpack_public_path__ + "img/firework-0.7311fd65.png";